import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';

export default function ArticleListPage() {
  const articlesByCategory: Record<string, typeof articles> = {};
  articles.forEach((a) => {
    if (!articlesByCategory[a.category]) {
      articlesByCategory[a.category] = [];
    }
    articlesByCategory[a.category].push(a);
  });

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '全部文章 - hth官方平台',
    description: '浏览hth平台全部文章资讯，了解最新动态与使用指南。',
    url: 'https://www.hth-platform.com/article',
    isPartOf: {
      '@type': 'WebSite',
      name: 'hth官方平台',
      url: 'https://www.hth-platform.com/',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />
      <ScrollToTop />
      <div className="min-h-screen">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100">
            <div className="w-full px-4 md:px-6 py-10 md:py-14">
              <div className="max-w-6xl mx-auto">
                <div className="mb-4">
                  <Breadcrumb
                    items={[
                      { label: '首页', path: '/' },
                      { label: '全部文章' },
                    ]}
                  />
                </div>
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                  全部文章
                </h1>
                <p className="mt-2 text-sm md:text-base text-foreground-500">
                  浏览hth平台最新资讯与实用指南
                </p>
              </div>
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-10">
            <div className="max-w-6xl mx-auto">
              {Object.entries(articlesByCategory).map(([category, items]) => (
                <section key={category} className="mb-12">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                    {category}
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {items.map((article) => (
                      <Link
                        key={article.slug}
                        to={`/article/${article.slug}`}
                        className="group p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-200 transition-all cursor-pointer"
                      >
                        <div className="w-full aspect-[16/10] rounded-md overflow-hidden bg-background-100">
                          <img
                            src={article.imageUrl}
                            alt={article.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                          />
                        </div>
                        <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                          {article.title}
                        </h3>
                        <p className="mt-2 text-sm text-foreground-500 line-clamp-2">
                          {article.description}
                        </p>
                        <div className="mt-3 flex items-center justify-between">
                          <div className="flex flex-wrap gap-1.5">
                            {article.tags.slice(0, 2).map((tag) => (
                              <span
                                key={tag}
                                className="px-2 py-0.5 text-xs rounded-full bg-accent-50 text-accent-600"
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                          <span className="text-xs text-foreground-400">{article.date}</span>
                        </div>
                      </Link>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}